exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_httpError_3NT7aBtbnxIYP28rVgDIBg {\n  margin-top: 20px;\n  padding: 20px;\n  height: auto;\n  background-color: #fff6db;\n  box-sizing: border-box;\n  line-height: 21px;\n}\n\n.IA_httpError_3NT7aBtbnxIYP28rVgDIBg:after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n\n.IA_httpError_3NT7aBtbnxIYP28rVgDIBg .icon_2kSVGwzYVIJFECxpXMEeK1 {\n  float: left;\n}\n\n.IA_httpError_3NT7aBtbnxIYP28rVgDIBg .message_3EIcsQ8oZxqU9oap0l_TXm {\n  margin-top: 10px;\n  clear: both;\n  float: left;\n  font-size: 14px;\n}", ""]);

// Exports
exports.locals = {
	"IA_httpError": "IA_httpError_3NT7aBtbnxIYP28rVgDIBg",
	"icon": "icon_2kSVGwzYVIJFECxpXMEeK1",
	"message": "message_3EIcsQ8oZxqU9oap0l_TXm"
};